import { render, staticRenderFns } from "./CustomerArchivedTab.htm?vue&type=template&id=fc2a4dcc&"
import script from "./CustomerArchivedTab.ts?vue&type=script&lang=js&"
export * from "./CustomerArchivedTab.ts?vue&type=script&lang=js&"
import style0 from "./CustomerArchivedTab.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../MyVacanciesTab.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports